/**
 * GA4 tracking helpers. One lazy-loaded gtag.js instance (see /public/index.html) configured
 * with GA4 G-68KVF8ZJBV and Google Ads AW-17789400799. The Ads account imports GA4 conversions,
 * so there are NO Google Ads website-conversion tags here (they would double-count).
 *
 * Form conversions fire exactly once, on thank-you page load (see lib/thankYou.js + ThankYouPage).
 */

const GA4_ID = "G-68KVF8ZJBV";
const ADS_ID = "AW-17789400799";

// Conversion value per lead type (USD).
export const CONVERSION_VALUES = {
  contact_page_booking: 89,
  contact_page_message: 25,
  commercial_intake: 250,
  pm_plan_inquiry: 150,
  lead_magnet_checklist: 25,
  phone_call: 50,
};

const safeGtag = (...args) => {
  if (typeof window === "undefined") return;
  if (typeof window.gtag !== "function") return;
  try {
    window.gtag(...args);
  } catch (e) {
    // analytics must never crash the app
    // eslint-disable-next-line no-console
    console.warn("gtag error", e);
  }
};

// PM Plan — page view + tier interaction (engagement only, not conversions).
export const trackPmPlanView = () => {
  safeGtag("event", "view_item_list", { send_to: [GA4_ID, ADS_ID], item_list_id: "pm_plans", item_list_name: "Preventive Maintenance Plans" });
};
export const trackPmTierClick = (tier) => {
  safeGtag("event", "select_item", { send_to: [GA4_ID, ADS_ID], item_list_id: "pm_plans", items: [{ item_id: `pm_${String(tier).toLowerCase()}`, item_name: `${tier} PM Plan` }] });
};

// Phone tap-to-call — fires immediately on tap (value 50).
export const trackPhoneClick = (source = "unknown") => {
  safeGtag("event", "click", {
    event_category: "engagement",
    event_label: `phone_call_${source}`,
    transport_type: "beacon",
  });
  safeGtag("event", "generate_lead", {
    send_to: [GA4_ID, ADS_ID],
    currency: "USD",
    value: CONVERSION_VALUES.phone_call,
    lead_source: source,
    method: "phone",
  });
};

// Form lead conversion — called ONLY by ThankYouPage, once per submission.
export const trackLeadConversion = ({ leadType, value, leadId, details = {} }) => {
  safeGtag("event", "generate_lead", {
    send_to: [GA4_ID, ADS_ID],
    currency: "USD",
    value,
    lead_source: leadType,
    method: "form",
    ...(leadId ? { transaction_id: leadId } : {}),
    ...details,
  });
};

export const trackEvent = (name, params = {}) => {
  safeGtag("event", name, params);
};
